<template>
  <div class="CostIntro" ref="section">
    <div
      class="CostIntro-animation"
      :class="{ 'animation-triggered': gifVisible }"
    >
      <div class="frame-container">
        <img
          v-if="gifVisible && currentImage"
          :src="currentImage"
          alt="Cost Intro Animation"
          key="sequence-frame"
          class="frame-img"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      gifVisible: false,
      hasPlayed: false,
      currentFrame: 1,
      totalFrames: 112,
      frameLoaded: {},
      autoplayTimer: null,
      fps: 24,
      basePath: '/mp4/TSN/Cost/Cost_phone_intro/frame_'
    }
  },
  computed: {
    currentImage() {
      const cur = this.currentFrame
      return this.frameLoaded[cur] ? this.frameLoaded[cur].src : null
    }
  },
  mounted() {
    this.preloadAllFrames()

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio >= 0.66 && !this.hasPlayed) {
          this.hasPlayed = true
          this.startAutoplay()
          observer.disconnect()
        }
      },
      { threshold: [0, 0.33, 0.66, 1] }
    )
    observer.observe(this.$refs.section)
  },
  beforeUnmount() {
    this.stopAutoplay()
  },
  methods: {
    preloadAllFrames() {
      let loadedCount = 0
      for (let i = 1; i <= this.totalFrames; i++) {
        const n = String(i).padStart(3, '0')
        const img = new Image()
        img.src = `${this.basePath}${n}.jpg`
        img.onload = () => {
          this.$set 
            ? this.$set(this.frameLoaded, i, img) 
            : (this.frameLoaded[i] = img)
          loadedCount++
          if (loadedCount === this.totalFrames) {
            this.gifVisible = true
            if (this.hasPlayed) this.startAutoplay()
          }
        }
      }
    },
    startAutoplay() {
      this.stopAutoplay()
      this.autoplayTimer = setInterval(() => {
        if (this.currentFrame < this.totalFrames) {
          this.currentFrame++
        } else {
          this.currentFrame = 1 // 循環播放
        }
      }, 1000 / this.fps)
    },
    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer)
        this.autoplayTimer = null
      }
    }
  }
}
</script>

<style scoped>
.CostIntro {
/* removed min-height */
/* removed flex */
/* removed justify-content */
/* removed align-items */
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.CostIntro-animation {
  opacity: 0;
  transition: opacity 0.8s ease;
  width: 100%;
}
.CostIntro-animation.animation-triggered {
  opacity: 1;
}

.frame-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.frame-img {
  width: 100%;
  /* max-height removed */
  height: auto;
  display: block;
}
</style>
